export const isPublishOverlapping = (recentPublishes: string[][], requestedBuckets: string[]): boolean =>
  recentPublishes.some((publishedBuckets) => publishedBuckets.some((bucket) => requestedBuckets.includes(bucket)));

export const buildDeployRequestBody = (userEmail: string, buckets: string[]) => ({
  user_email: userEmail,
  ...(buckets.length > 0 && { buckets }),
});

export const ALL_DEPLOYS = 'all';

export const normalizeDeploySelection = (values: string[]): string[] =>
  values.at(-1) === ALL_DEPLOYS ? [ALL_DEPLOYS] : values.filter((value) => value !== ALL_DEPLOYS);
